import axios from "axios";
import configs from "config";

export const getProviders = async (): Promise<any> => {
  try {
    const response = await axios.get(`${configs.baseURL}/GetIsps`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response && response.data) {
      console.log("response===>", response.data);
      return response.data;
    } else {
      throw Error(response.data.msg_retorno);
    }
  } catch (error) {
    //@ts-ignore
    const errorMessage = error?.response?.data?.msg_retorno || error?.message;

    return {
      message: errorMessage || "Internal server error",
    };
  }
};
